import type { IconType } from "react-icons";
import {
  LuBarChart3,
  LuBoxes,
  LuClipboardList,
  LuPackagePlus,
  LuSettings,
  LuUsers,
  LuWrench,
} from "react-icons/lu";
import { UserAccessProps } from "../core/session/components/UserAccess";

export type RouteSection = "Operaciones" | "Gestión" | "Análisis";

export interface Route {
  label: string;
  href: string;
  permissions?: UserAccessProps["roles"];
  subRoutes?: Route[][];
  section?: RouteSection;
  icon?: IconType;
}

export const ROUTE_SECTIONS: RouteSection[] = [
  "Operaciones",
  "Gestión",
  "Análisis",
];

export const ROUTES: Route[] = [
  {
    label: "Vales",
    href: "/vouchers",
    permissions: ["admin", "supervisor"],
    section: "Operaciones",
    icon: LuClipboardList,
  },
  {
    label: "Reposiciones",
    href: "/replenishments",
    permissions: ["admin", "supervisor"],
    section: "Operaciones",
    icon: LuPackagePlus,
  },
  {
    label: "Solicitantes",
    href: "/applicants",
    permissions: ["admin", "supervisor"],
    section: "Operaciones",
    icon: LuUsers,
  },
  {
    label: "Órdenes de trabajo",
    href: "/work-orders",
    permissions: ["admin", "supervisor"],
    section: "Gestión",
    icon: LuWrench,
  },
  {
    label: "Productos",
    href: "",
    permissions: ["admin", "supervisor"],
    section: "Gestión",
    icon: LuBoxes,
    subRoutes: [
      [
        {
          label: "Productos locales",
          href: "/product-local",
        },
        {
          label: "Productos ERP",
          href: "/product-erp",
        },
        {
          label: "Reajuste de productos",
          href: "/product-adjustment",
        },
      ],
      [
        {
          label: "Productos alias",
          href: "/product-alias",
        },
        {
          label: "Kits",
          href: "/kits",
        },
      ],
    ],
  },
  {
    label: "Reportes",
    permissions: ["admin", "supervisor"],
    href: "",
    section: "Análisis",
    icon: LuBarChart3,
    subRoutes: [
      [
        {
          label: "Reporte EPP",
          href: "/report-epp",
        },
      ],
      [
        {
          label: "Reporte general",
          href: "/report-general",
        },
      ],
    ],
  },
  {
    label: "Administración",
    permissions: ["admin", "supervisor"],
    href: "",
    section: "Análisis",
    icon: LuSettings,
    subRoutes: [
      [
        {
          label: "Empresas clientes",
          href: "/client-entities",
          permissions: ["admin", "supervisor"],
        },
        {
          label: "Etiquetas de actividad",
          href: "/activity-labels",
          permissions: ["admin", "supervisor"],
        },
      ],
    ],
  },
];

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

export const getBreadcrumbForPath = (
  pathname: string,
): BreadcrumbItem[] | undefined => {
  for (const route of ROUTES) {
    if (route.href && route.href === pathname) {
      return [
        ...(route.section ? [{ label: route.section }] : []),
        { label: route.label, href: route.href },
      ];
    }
    for (const group of route.subRoutes ?? []) {
      for (const subRoute of group) {
        if (subRoute.href === pathname) {
          return [
            ...(route.section ? [{ label: route.section }] : []),
            { label: route.label },
            { label: subRoute.label, href: subRoute.href },
          ];
        }
      }
    }
  }
  return undefined;
};
